import { render } from "./MessagingEmptyState.vue?vue&type=template&id=2caa133e"
import script from "./MessagingEmptyState.vue?vue&type=script&lang=js"
export * from "./MessagingEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__